
export const DragTypes = {
   EVENT: "event",
   PLANNER_VEHICLE: "planner-vehicle",
   PLANNER_BAY_ORDER: "planner-bay-order",
   DROP_OFF_LEAD: "drop-off-lead",
   IMAGE_TYPE_ORDER: "image-type-order",
}
